export default __webpack_public_path__ + "static/media/filter-icon.29228013.svg";